import classNames from "classnames";
import AngleLeftIcon from "@svg/angle-left";

interface Props {
  direction: "next" | "prev";
}

const SwiperNavigationButton = ({ direction }: Props) => {
  const isNext = direction === "next";

  return (
    <div
      className={classNames(
        `swiper-button-${direction}-category`,
        "absolute top-1/2 z-20 hidden -translate-y-1/2 items-center justify-center transition-all sm:flex",
        isNext ? "-left-11" : "-right-11"
      )}
    >
      <div
        className={classNames(
          "pointer-events-none absolute top-1/2 h-24 w-28 -translate-y-1/2",
          isNext
            ? "left-2/4 bg-gradient-to-r from-white"
            : "right-2/4 bg-gradient-to-l from-white"
        )}
      />

      <AngleLeftIcon
        className={classNames(
          "z-30 h-10 w-10 cursor-pointer rounded-full bg-fds-inverse p-3 text-white",
          !isNext && "-rotate-180"
        )}
      />
    </div>
  );
};

export default SwiperNavigationButton;
